import React from 'react'
import { Form, Row, Col, Button, Typography } from 'antd'
import { ModeContext } from '../../provider/ModeProvider'

const { Title } = Typography

const DeductionInitializeForm: React.FC = () => {
    const { setDeductionMode } = ModeContext()

    return (
        <>
            <Row>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <Form.Item>
                        <Title level={5}>Create Deduction</Title>
                        Created deduction will be set on Pending status at creation. This status will enable you to simulate both available Accepted and Rejected status for
                        Rejected status for Funding later.
                    </Form.Item>
                    <Form.Item>
                        <Button onClick={() => setDeductionMode('deduction-create')}>Next</Button>
                    </Form.Item>
                </Col>
            </Row>

            <br />
            <Row>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <Form.Item>
                        <Title level={5}>Update Deduction</Title>
                        Update Deduction is a feature that allows users to modify status of the deduction. You can simulate both Accepted and Rejected status for Deduction.
                    </Form.Item>
                    <Form.Item>
                        <Button onClick={() => setDeductionMode('deduction-update')}>Next</Button>
                    </Form.Item>
                </Col>
            </Row>
            <br />
        </>
    )
}

export default DeductionInitializeForm
